<template>
    <div>
      <div class="flex justify-between align-items-start flex-wrap-reverse mb-2">
        <div class="mb-2">
          <select v-model="selected_profile" @change="change_profile()" class="form-control w-auto custom-select">
            <option v-for="(index, key) in localProfiles" :value="key">{{ profiles[key]['name'] }}</option>
          </select>
        </div>
        <div class="flex flex-wrap">
          <div class="flex align-items-center mb-3 mr-4">
            <div class="bg-success mr-2 info-cube"></div>
            <span>Geaccepteerd</span>
          </div>
          <div class="flex align-items-center mb-3">
            <div class="bg-danger mr-2 info-cube"></div>
            <span>Afgewezen</span>
          </div>
        </div>
      </div>

      <div id="profiles_wrap"></div>
    </div>
</template>

<script>
import {createApp, defineComponent} from 'vue';
import WorkedTimeIndex from './WorkedTimeIndexComponent.vue';

export default {
    data() {
        return {
            used_profiles: {},
            old_selected_profile: 0,
            selected_profile: 0,
            dynamicComponentInstance: null,
            localProfiles: this.profiles,
        };
    },
    props: {
        profiles: {},
        worked_time_statuses: {},
        regular_worked_time_statuses: {},
        overwork_time_statuses: {},
        regular_overwork_time_statuses: {},
        csrf_token: String,
        company_demo_not_expired: {},
    },
    mounted() {
        this.$nextTick(function () {
            for (let key in this.localProfiles) {
                if (!this.localProfiles[key]['name']) {
                    this.localProfiles[key]['name'] = this.profiles[key]['fullName'];
                }
            }
            this.selected_profile = this.localProfiles[Object.keys(this.localProfiles)[0]]['id'];
            this.change_profile();
        });
    },
    methods: {
        change_profile: function () {
            if (this.used_profiles[this.selected_profile]) {
                document.getElementById(this.selected_profile).classList.remove('d-none');
            } else {
                this.used_profiles[this.selected_profile] = true;
                let worked_time_index_wrap = document.createElement('div');
                worked_time_index_wrap.id = this.selected_profile;

                const WorkedTimeIndexComponent = defineComponent({
                    extends: WorkedTimeIndex,
                    props: {
                        profile_in_use: Object,
                        worked_time_statuses: Object,
                        regular_worked_time_statuses: Object,
                        overwork_time_statuses: Object,
                        regular_overwork_time_statuses: Object,
                        csrf_token: String,
                        site_position: String,
                        company_is_free: Boolean,
                        company_demo_not_expired: Boolean,
                    },
                });

                this.dynamicComponentInstance = createApp(WorkedTimeIndexComponent, {
                    // Pass required props here
                    profile_in_use: this.localProfiles[this.selected_profile],
                    worked_time_statuses: this.worked_time_statuses,
                    regular_worked_time_statuses: this.regular_worked_time_statuses,
                    overwork_time_statuses: this.overwork_time_statuses,
                    regular_overwork_time_statuses: this.regular_overwork_time_statuses,
                    csrf_token: this.csrf_token,
                    site_position: 'employer', // Assuming this value is constant
                    company_is_free: false, // Assuming this value is constant
                    company_demo_not_expired: this.company_demo_not_expired,
                });

                let newDiv = document.createElement('div');
                this.dynamicComponentInstance.mount(newDiv);
                worked_time_index_wrap.appendChild(newDiv);
                document.getElementById('profiles_wrap').appendChild(worked_time_index_wrap);
            }

            if (this.old_selected_profile) {
                document.getElementById(this.old_selected_profile).classList.add('d-none');
            }
            this.old_selected_profile = this.selected_profile;
        },
    },
};
</script>
